import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="footer" data-testid="site-footer">
    <div className="shell footer-inner">
      <span data-testid="footer-copyright">© {new Date().getFullYear()} The Blake Smith Company LLC</span>
      <nav aria-label="Footer navigation" className="footer-links">
        <a href="/#services" data-testid="footer-services-link">Services</a>
        <Link to="/work" data-testid="footer-work-link">Work</Link>
        <Link to="/founder" data-testid="footer-founder-link">Founder</Link>
        <a href="/#contact" data-testid="footer-contact-link">Contact</a>
      </nav>
    </div>
  </footer>
);
